import * as React from 'react';
import {useCallback} from 'react';
import formConnect from '../formConnect';
import {getFormError, clearSubmitErrors, ConfigProps, InjectedFormProps} from 'redux-form';
import Alert from '@material-ui/core/Alert';

export default formConnect<{
  error: InjectedFormProps['error'];
  clearSubmitErrors: typeof clearSubmitErrors;
  form: ConfigProps['form'];
}>((state, {form}) => ({error: getFormError(form)(state)}), {clearSubmitErrors})(function({
  error,
  clearSubmitErrors,
  form,
}) {
  return <Alert onClose={useCallback(() => clearSubmitErrors(form), [clearSubmitErrors])}>{error}</Alert>;
});
